import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 80px;
`

const Main = ({ children }) => <Container>{children}</Container>

export default Main
